// extracted by mini-css-extract-plugin
export default {"root":"Cursor_root__nUPgQ","cell":"Cursor_cell__9Rcv9","arrow":"Cursor_arrow__mycHk"};